import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

// Order Core (шаг S9a) — только чтение: агрегат заказов, журнал событий,
// расхождения и состояние контура. Действий над заказами здесь нет.
const BASE = `${API_BASE_URL}/orders/core`;

const getAuthHeaders = () => {
    const token = getAccessToken();
    if (!token) {
        window.location.href = "/";
    }
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};

const dropEmpty = (params) => Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value !== undefined && value !== null && value !== ""),
);

export const getOrderCoreOverview = async () => {
    const response = await axios.get(`${BASE}/overview`, getAuthHeaders());
    return response.data;
};

export const getOrderCoreOrders = async (params) => {
    const response = await axios.get(`${BASE}/orders`, { ...getAuthHeaders(), params: dropEmpty(params) });
    return response.data;
};

export const getOrderCoreOrder = async (orderId) => {
    const response = await axios.get(`${BASE}/orders/${orderId}`, getAuthHeaders());
    return response.data;
};

export const getOrderCoreSnapshot = async (orderId, snapshotId) => {
    const response = await axios.get(`${BASE}/orders/${orderId}/snapshots/${snapshotId}`, getAuthHeaders());
    return response.data;
};

export const getOrderCoreIssues = async (params) => {
    const response = await axios.get(`${BASE}/issues`, { ...getAuthHeaders(), params: dropEmpty(params) });
    return response.data;
};

export const getOrderCoreMismatchReport = async (params) => {
    const response = await axios.get(`${BASE}/mismatch-report`, { ...getAuthHeaders(), params: dropEmpty(params) });
    return response.data;
};
